export default "__VITE_ASSET__CpTn_kjl__"